<section class="c-block-type" cypressTag="General.Block" [class]="'c-block-type--' + blockTypes[type]">
	<ng-content></ng-content>
</section>
